import { render } from "./CustomersList.vue?vue&type=template&id=41116a12&scoped=true&ts=true"
import script from "./CustomersList.vue?vue&type=script&lang=ts"
export * from "./CustomersList.vue?vue&type=script&lang=ts"

import "./CustomersList.vue?vue&type=style&index=0&id=41116a12&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41116a12"]])

export default __exports__